import { useContext } from "react";

import { AgendaItemsContextMenuContext } from "./AgendaItemsContextMenuContext";

export function useAgendaItemsContextMenu() {
  const context = useContext(AgendaItemsContextMenuContext);
  if (!context) {
    throw new Error("useAgendaItemsContextMenu must be used within a AgendaItemsContextMenuProvider");
  }
  return context;
}
